import { gql } from '__generated__';

export const GET_TENANTS_FOR_EMAIL = gql(/* GraphQL */ `
  query getTenantsForEmail($email: String!) {
    getTenantsForEmail(email: $email) {
      id
      name
    }
  }
`);
